export const API_URL = "https://backend.smarttechsolution.lk";
